import React, { Component } from 'react';
import { useParams, Link } from 'react-router-dom';
import { CalendarIcon, UsersIcon, ClockIcon, MapPinIcon, CheckIcon, PhoneIcon, MessageSquareIcon } from 'lucide-react';
// Destination data with detailed information
const destinationsData = [{
  id: 1,
  name: 'Turkey',
  image: 'https://images.unsplash.com/photo-1589561454226-796a8aa89b05?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1169&q=80',
  description: 'Discover the beauty of Istanbul, Cappadocia, and the Turkish Riviera',
  longDescription: 'Turkey offers a captivating blend of Eastern and Western cultures, with stunning landscapes, ancient historical sites, and vibrant cities. From the bustling streets of Istanbul to the fairy chimneys of Cappadocia and the turquoise waters of the Mediterranean coast, Turkey is a destination that offers something for every traveler.',
  highlights: ['Istanbul', 'Cappadocia', 'Antalya', 'Pamukkale', 'Bodrum'],
  packages: [{
    id: 101,
    title: 'Istanbul Explorer',
    image: 'https://images.unsplash.com/photo-1524231757912-21f4fe3a7200?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1171&q=80',
    price: '$799',
    duration: '5 days',
    groupSize: '10 people',
    startDate: 'Multiple dates'
  }, {
    id: 102,
    title: 'Cappadocia Hot Air Balloon Tour',
    image: 'https://images.unsplash.com/photo-1570654230464-9cf63245bee7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    price: '$1,099',
    duration: '4 days',
    groupSize: '8 people',
    startDate: 'Multiple dates'
  }, {
    id: 103,
    title: 'Turkish Riviera Cruise',
    image: 'https://images.unsplash.com/photo-1519451241324-20b4ea2c4220?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '$1,299',
    duration: '7 days',
    groupSize: '12 people',
    startDate: 'Multiple dates'
  }]
}, {
  id: 2,
  name: 'Dubai',
  image: 'https://images.unsplash.com/photo-1512453979798-5ea266f8880c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  description: 'Experience luxury and adventure in the city of gold',
  longDescription: "Dubai is a city of superlatives, home to the world's tallest building, largest mall, and most luxurious hotels. This modern metropolis rises from the desert, offering visitors a unique blend of futuristic architecture, high-end shopping, thrilling desert adventures, and rich cultural experiences that showcase both traditional Emirati heritage and cosmopolitan flair.",
  highlights: ['Burj Khalifa', 'Palm Jumeirah', 'Dubai Mall', 'Desert Safari', 'Miracle Garden'],
  packages: [{
    id: 201,
    title: 'Dubai Luxury Experience',
    image: 'https://images.unsplash.com/photo-1582672752488-08797d00d8a8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '$1,299',
    duration: '7 days',
    groupSize: '8 people',
    startDate: 'Multiple dates'
  }, {
    id: 202,
    title: 'Dubai Adventure Package',
    image: 'https://images.unsplash.com/photo-1584551246679-0daf3d275d0f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '$999',
    duration: '5 days',
    groupSize: '10 people',
    startDate: 'Multiple dates'
  }]
}, {
  id: 3,
  name: 'Thailand',
  image: 'https://images.unsplash.com/photo-1528181304800-259b08848526?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
  description: 'Explore tropical beaches and ancient temples',
  longDescription: 'Thailand captivates visitors with its perfect blend of stunning beaches, lush jungles, vibrant cities, and rich cultural heritage. From the bustling streets of Bangkok to the serene temples of Chiang Mai and the paradise islands of the south, Thailand offers unforgettable experiences, warm hospitality, and delicious cuisine that will leave you wanting to return again and again.',
  highlights: ['Bangkok', 'Phuket', 'Chiang Mai', 'Krabi', 'Phi Phi Islands'],
  packages: [{
    id: 301,
    title: 'Thailand Beach Getaway',
    image: 'https://images.unsplash.com/photo-1552465011-b4e21bf6e79a?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1139&q=80',
    price: '$899',
    duration: '6 days',
    groupSize: '12 people',
    startDate: 'Multiple dates'
  }, {
    id: 302,
    title: 'Phuket Island Hopping',
    image: 'https://images.unsplash.com/photo-1537956965359-7573183d1f57?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1168&q=80',
    price: '$849',
    duration: '5 days',
    groupSize: '12 people',
    startDate: 'Multiple dates'
  }, {
    id: 303,
    title: 'Thailand Cultural Experience',
    image: 'https://images.unsplash.com/photo-1563492065599-3520f775eeed?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    price: '$1,099',
    duration: '8 days',
    groupSize: '10 people',
    startDate: 'Multiple dates'
  }]
}, {
  id: 4,
  name: 'Malaysia',
  image: 'https://images.unsplash.com/photo-1596422846543-75c6fc197f07?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1164&q=80',
  description: 'Visit Kuala Lumpur, Penang, and beautiful island resorts',
  longDescription: 'Malaysia is a diverse country that offers travelers an exciting mix of modern cities, colonial architecture, beautiful beaches, and ancient rainforests. From the towering Petronas Towers in Kuala Lumpur to the historic streets of Penang and the pristine beaches of Langkawi, Malaysia combines natural beauty with rich cultural heritage and delicious cuisine influenced by Malay, Chinese, and Indian traditions.',
  highlights: ['Kuala Lumpur', 'Penang', 'Langkawi', 'Borneo', 'Cameron Highlands'],
  packages: [{
    id: 401,
    title: 'Kuala Lumpur City Break',
    image: 'https://images.unsplash.com/photo-1508098682722-e99c43a406b2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '$699',
    duration: '4 days',
    groupSize: '10 people',
    startDate: 'Multiple dates'
  }, {
    id: 402,
    title: 'Malaysian Island Paradise',
    image: 'https://images.unsplash.com/photo-1590077428593-a55bb07c4665?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    price: '$999',
    duration: '6 days',
    groupSize: '8 people',
    startDate: 'Multiple dates'
  }]
}, {
  id: 5,
  name: 'Europe',
  image: 'https://images.unsplash.com/photo-1503917988258-f87a78e3c995?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1887&q=80',
  description: 'Discover the rich history, culture, and beauty of Europe',
  longDescription: 'Europe offers an incredible diversity of experiences, from the romantic streets of Paris and the ancient ruins of Rome to the stunning fjords of Norway and the sun-drenched beaches of the Mediterranean. With its rich history, world-class art and architecture, delicious cuisine, and picturesque landscapes, Europe provides endless opportunities for exploration and discovery.',
  highlights: ['Paris', 'Rome', 'Barcelona', 'London', 'Amsterdam'],
  packages: [{
    id: 501,
    title: 'European Capitals Tour',
    image: 'https://images.unsplash.com/photo-1499856871958-5b9357976b82?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1220&q=80',
    price: '$2,499',
    duration: '12 days',
    groupSize: '15 people',
    startDate: 'Multiple dates'
  }, {
    id: 502,
    title: 'Mediterranean Cruise',
    image: 'https://images.unsplash.com/photo-1565865735988-7157af4e7dee?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '$1,899',
    duration: '10 days',
    groupSize: '20 people',
    startDate: 'Multiple dates'
  }]
}, {
  id: 6,
  name: 'Maldives',
  image: 'https://images.unsplash.com/photo-1514282401047-d79a71a590e8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1965&q=80',
  description: 'Experience paradise on earth with crystal clear waters and overwater bungalows',
  longDescription: "The Maldives is the ultimate tropical paradise, featuring pristine white-sand beaches, crystal-clear turquoise waters, and luxurious overwater bungalows. This island nation offers unparalleled opportunities for relaxation, romance, and underwater adventures, with some of the world's best snorkeling and diving sites teeming with colorful coral reefs and marine life.",
  highlights: ['Male', 'Overwater Villas', 'Snorkeling', 'Diving', 'Island Hopping'],
  packages: [{
    id: 601,
    title: 'Maldives Luxury Retreat',
    image: 'https://images.unsplash.com/photo-1573843981267-be1999ff37cd?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1074&q=80',
    price: '$2,999',
    duration: '7 days',
    groupSize: '2 people',
    startDate: 'Multiple dates'
  }, {
    id: 602,
    title: 'Maldives Island Hopping',
    image: 'https://images.unsplash.com/photo-1586861635167-e5223aadc9fe?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80',
    price: '$2,499',
    duration: '8 days',
    groupSize: '4 people',
    startDate: 'Multiple dates'
  }]
}];
const DestinationDetails = () => {
  const {
    id
  } = useParams();
  const destinationId = parseInt(id || '1');
  const destination = destinationsData.find(dest => dest.id === destinationId);
  if (!destination) {
    return <div className="container mx-auto px-4 py-16 text-center" data-id="element-412">
        <h2 className="text-3xl font-bold text-gray-900" data-id="element-413">
          Destination not found
        </h2>
        <Link to="/destinations" className="mt-6 inline-block bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-md" data-id="element-414">
          Back to Destinations
        </Link>
      </div>;
  }
  // Function to create WhatsApp link for package inquiries
  const createWhatsAppLink = packageTitle => {
    const message = `Hello, I'm interested in the ${packageTitle} for ${destination.name}. Could you please provide more information?`;
    return `https://wa.me/96599886331?text=${encodeURIComponent(message)}`;
  };
  return <div className="bg-white" data-id="element-415">
      {/* Hero Section */}
      <div className="relative bg-cover bg-center h-96" style={{
      backgroundImage: `url(${destination.image})`
    }} data-id="element-416">
        <div className="absolute inset-0 bg-black bg-opacity-50" data-id="element-417"></div>
        <div className="container mx-auto px-4 h-full flex items-center relative z-10" data-id="element-418">
          <div data-id="element-419">
            <h1 className="text-4xl md:text-5xl font-bold text-white mb-4" data-id="element-420">
              {destination.name}
            </h1>
            <p className="text-xl text-white max-w-2xl" data-id="element-421">
              {destination.description}
            </p>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 py-16" data-id="element-422">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12" data-id="element-423">
          {/* Left Column - Description and Highlights */}
          <div className="lg:col-span-2" data-id="element-424">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-425">
              About {destination.name}
            </h2>
            <p className="text-gray-700 mb-8 text-lg leading-relaxed" data-id="element-426">
              {destination.longDescription}
            </p>
            <div className="mb-12" data-id="element-427">
              <h3 className="text-2xl font-semibold text-gray-900 mb-4" data-id="element-428">
                Highlights
              </h3>
              <ul className="space-y-3" data-id="element-429">
                {destination.highlights.map((highlight, index) => <li key={index} className="flex items-start" data-id="element-430">
                    <CheckIcon size={20} className="text-blue-600 mr-3 mt-1" data-id="element-431" />
                    <span className="text-gray-700" data-id="element-432">{highlight}</span>
                  </li>)}
              </ul>
            </div>
          </div>
          {/* Right Column - Contact Form */}
          <div data-id="element-433">
            <div className="bg-gray-50 p-6 rounded-lg shadow-md" data-id="element-434">
              <h3 className="text-xl font-semibold text-gray-900 mb-4" data-id="element-435">
                Inquire About This Destination
              </h3>
              <form onSubmit={e => {
              e.preventDefault();
              const name = e.target.name.value;
              const email = e.target.email.value;
              const phone = e.target.phone.value;
              const message = e.target.message.value;
              const whatsappMessage = `Hello, I'm interested in traveling to ${destination.name}.\n\nName: ${name}\nEmail: ${email}\nPhone: ${phone}\n\nMessage: ${message}`;
              window.open(`https://wa.me/96599886331?text=${encodeURIComponent(whatsappMessage)}`, '_blank');
            }} data-id="element-436">
                <div className="mb-4" data-id="element-437">
                  <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-438">
                    Your Name
                  </label>
                  <input type="text" id="name" name="name" className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required data-id="element-439" />
                </div>
                <div className="mb-4" data-id="element-440">
                  <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-441">
                    Email
                  </label>
                  <input type="email" id="email" name="email" className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required data-id="element-442" />
                </div>
                <div className="mb-4" data-id="element-443">
                  <label htmlFor="phone" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-444">
                    Phone
                  </label>
                  <input type="tel" id="phone" name="phone" className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" required data-id="element-445" />
                </div>
                <div className="mb-4" data-id="element-446">
                  <label htmlFor="message" className="block mb-2 text-sm font-medium text-gray-900" data-id="element-447">
                    Message
                  </label>
                  <textarea id="message" name="message" rows={4} className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5" defaultValue={`I'm interested in traveling to ${destination.name} and would like more information.`} required data-id="element-448"></textarea>
                </div>
                <button type="submit" className="w-full bg-green-600 hover:bg-green-700 text-white font-medium rounded-lg text-sm px-5 py-3 text-center flex items-center justify-center" data-id="element-449">
                  <MessageSquareIcon size={18} className="mr-2" data-id="element-450" />
                  Contact via WhatsApp
                </button>
              </form>
              <div className="mt-6 text-center" data-id="element-451">
                <p className="text-sm text-gray-600 mb-2" data-id="element-452">
                  Or contact us directly
                </p>
                <div className="flex justify-center space-x-4" data-id="element-453">
                  <a href="tel:0096599886331" className="flex items-center text-blue-600 hover:text-blue-800" data-id="element-454">
                    <PhoneIcon size={16} className="mr-1" data-id="element-455" />
                    <span data-id="element-456">Call Us</span>
                  </a>
                  <a href="https://wa.me/96599886331" className="flex items-center text-green-600 hover:text-green-800" data-id="element-457">
                    <MessageSquareIcon size={16} className="mr-1" data-id="element-458" />
                    <span data-id="element-459">WhatsApp</span>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Available Packages */}
        <div className="mt-16" data-id="element-460">
          <h2 className="text-3xl font-bold text-gray-900 mb-8" data-id="element-461">
            Available Packages for {destination.name}
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-462">
            {destination.packages.map(pkg => <div key={pkg.id} className="bg-white rounded-lg shadow-md overflow-hidden hover:shadow-xl transition-shadow" data-id="element-463">
                <div className="relative" data-id="element-464">
                  <img src={pkg.image} alt={pkg.title} className="w-full h-56 object-cover" data-id="element-465" />
                  <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4" data-id="element-466">
                    <div className="text-white font-bold text-xl" data-id="element-467">
                      {pkg.title}
                    </div>
                    <div className="text-white font-semibold" data-id="element-468">
                      {pkg.price}{' '}
                      <span className="text-sm font-normal" data-id="element-469">per person</span>
                    </div>
                  </div>
                </div>
                <div className="p-6" data-id="element-470">
                  <div className="flex flex-col space-y-3 mb-4" data-id="element-471">
                    <div className="flex items-center text-gray-600" data-id="element-472">
                      <ClockIcon size={16} className="mr-2" data-id="element-473" />
                      <span data-id="element-474">{pkg.duration}</span>
                    </div>
                    <div className="flex items-center text-gray-600" data-id="element-475">
                      <UsersIcon size={16} className="mr-2" data-id="element-476" />
                      <span data-id="element-477">Max {pkg.groupSize}</span>
                    </div>
                    <div className="flex items-center text-gray-600" data-id="element-478">
                      <CalendarIcon size={16} className="mr-2" data-id="element-479" />
                      <span data-id="element-480">{pkg.startDate}</span>
                    </div>
                    <div className="flex items-center text-gray-600" data-id="element-481">
                      <MapPinIcon size={16} className="mr-2" data-id="element-482" />
                      <span data-id="element-483">{destination.name}</span>
                    </div>
                  </div>
                  <a href={createWhatsAppLink(pkg.title)} target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-700 text-white text-center py-2 rounded-md font-medium flex items-center justify-center" data-id="element-484">
                    <MessageSquareIcon size={18} className="mr-2" data-id="element-485" />
                    Inquire via WhatsApp
                  </a>
                </div>
              </div>)}
          </div>
        </div>
      </div>
    </div>;
};
export default DestinationDetails;